/** Change the viewer's operational callsign — used by Oracle everywhere. */
import React, { useState } from "react";
import { Fingerprint } from "lucide-react";
import { api } from "./commandApi";
import { refreshCallsign, useCallsign } from "./useCallsign";

export default function CallsignEditor({ onDone }) {
  const identity = useCallsign();
  const [value, setValue] = useState("");
  const [err, setErr] = useState(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!value.trim() || saving) return;
    setSaving(true); setErr(null);
    try {
      await api("/command/identity/callsign", { method: "put", data: { callsign: value } });
      await refreshCallsign();
      onDone();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Callsign rejected.");
    }
    setSaving(false);
  };

  return (
    <div className="px-4 py-3" data-testid="callsign-editor">
      <div className="font-mono text-[9px] uppercase tracking-[0.35em] text-[#D92D20] mb-2">
        // Operational Callsign
      </div>
      <p className="font-mono text-[10px] text-[#7B7168] leading-relaxed">
        Oracle addresses you exclusively by callsign — never by name. Current:{" "}
        <span className="text-[#E4DFD3]">{identity.callsign || "—"}</span>
      </p>
      <div className="mt-3 flex items-center gap-2 border border-[#2D2A26] px-2 py-1.5 focus-within:border-[#D92D20]/60">
        <Fingerprint size={12} className="text-[#5A554C]" />
        <input value={value}
               onChange={(e) => { setValue(e.target.value.toUpperCase()); setErr(null); }}
               onKeyDown={(e) => e.key === "Enter" && save()}
               placeholder="NEW-CALLSIGN…" maxLength={24}
               data-testid="callsign-input"
               className="flex-1 bg-transparent outline-none font-mono text-[13px] tracking-[0.15em] text-[#E4DFD3] placeholder:text-[#454038] caret-[#D92D20]" />
      </div>
      {err && (
        <div className="mt-2 font-mono text-[10px] text-[#E0A526]" data-testid="callsign-error">
          ▲ {err}
        </div>
      )}
      <div className="mt-2 font-mono text-[9px] text-[#5A554C]">
        2–24 chars · letters, numbers, hyphen, underscore · unique across The Archive.
        Previous callsigns are retained in the internal audit record only.
      </div>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={save} data-testid="callsign-save"
                className="font-mono text-[9px] uppercase tracking-[0.2em] px-2.5 py-1.5 border border-[#D92D20] text-[#E4DFD3] bg-[#1a0808] hover:bg-[#D92D20]/20">
          {saving ? "Registering…" : "Register Callsign"}
        </button>
        <button type="button" onClick={onDone} data-testid="callsign-cancel"
                className="font-mono text-[9px] uppercase tracking-[0.2em] px-2.5 py-1.5 border border-[#2D2A26] text-[#A39E93] hover:border-[#D92D20] hover:text-[#E4DFD3]">
          Back
        </button>
      </div>
    </div>
  );
}
